module.exports = __webpack_public_path__ + "img/78.a48a5c50.jpg";